import React from "react";
import {InputLabel} from "@mui/material";
import {CustomStyleLabel} from "./Styles";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description Label
 * @param String id: Identifier for the label (required)
 * @param String trans: Text for the label (required)
 * @param String forValue: Identifier for the associated element (optional)
 * @param String classes: Add extra classes in option item (optional)
 * @param String bold: Font weight for label (optional)
 * @returns {JSX.Element}
 */

const CustomInputLabel = ({labelId = "custom-label", trans, forValue, classes='', bold="bold"}) => {
    return <>
        <InputLabel id={labelId} sx={CustomStyleLabel(bold)} for={forValue} className={classes}>{trans}</InputLabel>
    </>
}

export default CustomInputLabel
